import WebsiteBehaviors from "../website-behaviors/index.js";
import Citation from "../citation.js";

class JSTOR extends WebsiteBehaviors {
	identifier() {
		return "JSTOR";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "jstor.org" || location.host === "www.jstor.org")
			&& location.pathname.startsWith("/stable/");
	}

	/**
	 * Loads RIS export URL, e.g. https://www.jstor.org/citation/ris/3649391
	 */
	async generateStructuredCitation() {
		// @ts-expect-error FIXME
		const url = new URL(window.location);

		// Get "123456789" from URL like "www.jstor.org/stable/123456789"
		const documentId = parseInt(url.pathname.split("/")[2], 10);
		if (!documentId)
			return null;

		const risUrl = new URL(`${url.protocol}//${url.hostname}/citation/ris/${documentId}`);
		const response = await fetch(risUrl);
		if (response.status !== 200)
			return null;

		return Citation.fromRIS(await response.text());
	}
}

export default JSTOR;
